document.querySelectorAll('[data-final-sale-config]').forEach(function (configEl) {
  var form = configEl.closest('form');
  if (!form) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var productForm = form.closest('product-form');
  if (!productForm) return;

  form.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;

    var isFinalSale = config[String(variant.id)] === true;

    var notice = productForm.parentNode.querySelector('.final-sale-notice');
    var input = form.querySelector('.js-final-sale-input');

    if (notice) notice.hidden = !isFinalSale;
    if (input) input.disabled = !isFinalSale;
  });
});
